import { render } from "./collabs.vue?vue&type=template&id=18bde557&scoped=true"
import script from "./collabs.vue?vue&type=script&lang=js"
export * from "./collabs.vue?vue&type=script&lang=js"

import "./collabs.vue?vue&type=style&index=0&id=18bde557&scoped=true&lang=css"

import exportComponent from "/Users/arissa/Desktop/code/portfolio/arissa-portfolio/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18bde557"]])

export default __exports__